import React, { Component } from "react";
import config from "../../../config";
import utilityFunctions from "../../../store/utilityFunctions";
import { MdClose } from "react-icons/md";
import { Table as MaterialTable } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import errorFunctions from "../../../store/errorFunctions";
// import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import "react-datepicker/dist/react-datepicker.css";

export default class AddTicket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      fromDate: null,
      toDate: null,
      showFilterModal: true,
      ticket: null,
      errorTxt: "",
      searchFilter: "",
    };
    const userInfo = utilityFunctions.getCookie("userInfo");
    this.userRole = JSON.parse(userInfo).user.role;
    this.user = JSON.parse(userInfo).user;
  }

  handleSearchTicket = () => {
    this.setState({ loading: true });

    const url = `${config.backendServer}tickets/commercial/?q=${this.state.searchFilter}`;

    this.props
      .protectedFetch(url, "GET", null, (res) => {
        return res; // Do everything in the 'then'
      })
      .then(async (res) => {
        if (res) {
          const ticket = await res.json();
          const isTicketExist = !!this.props.data.find((x) => x.ticket_number === ticket.ticket_number);
          if (isTicketExist) this.setState({ loading: false, errorTxt: "Ticket already on the list" });
          else
            this.setState({
              loading: false,
              ticket,
            });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, errorTxt: "Ticket not found", ticket: null });
      });
  };

  filterChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleKeyPressSearch = (e) => {
    if (e.key === "Enter") {
      this.handleSearchTicket();
    }
  };

  handleChangeTicketLocation = () => {
    this.setState({ loading: true });

    let payload = {
      store_location: this.props.userInfo.user.store_location_id,
    };

    this.props
      .protectedFetch(
        config.backendServer + `ticket/${this.state.ticket.id}/change-location/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        alert("Change location succes");
        this.props.retrieveWarranty(); //mini reload retrieveWarranty
        this.props.handleCloseModal();
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log("fail", err);
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <>
        <div className="card">
          <button onClick={() => this.props.handleCloseModal()} className={"confirm-modal-close"}>
            <MdClose />
          </button>
          <div className="card-header">
            <h6>Assign Existing Device</h6>
          </div>

          <div className={"card-body"}>
            <div className="input-group  mb-3 ">
              <input
                type="text"
                placeholder="Search tickets"
                id={"searchFilter"}
                className={"form-control col-8"}
                onChange={this.filterChange}
                onKeyDown={this.handleKeyPressSearch}
                // onInput={()=> alert("submit")}
                value={this.state.searchFilter}
                // width={"50px"}
              />
              <div className="input-group-prepend">
                <span className="form-control " onClick={this.handleSearchTicket}>
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
            <div>
              <TableContainer className="border">
                <MaterialTable aria-labelledby="tableTitle" size={"small"} aria-label="enhanced table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Ticket number</TableCell>
                      <TableCell>Owner name</TableCell>
                      <TableCell>Device name</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.ticket ? (
                      <TableRow>
                        <TableCell>{this.state.ticket.ticket_number}</TableCell>
                        <TableCell>{this.state.ticket.owner_name}</TableCell>
                        <TableCell>{this.state.ticket.device_name}</TableCell>
                        <TableCell>
                          <button className="k-btn k-btn-primary k-btn-sm" onClick={() => this.handleChangeTicketLocation()}>
                            Add Ticket
                          </button>
                        </TableCell>
                      </TableRow>
                    ) : (
                      // <TableRow className="d-flex gap-2">
                      //   <TableCell>{this.state.ticket.ticket_number}</TableCell>
                      //   <TableCell>{this.state.ticket.owner_name}</TableCell>
                      //   <TableCell>{this.state.ticket.device_name}</TableCell>
                      //   <TableCell>
                      //     <button className="k-btn k-btn-primary">Add Ticket</button>
                      //   </TableCell>
                      // </TableRow>
                      <TableRow>
                        <TableCell>{this.state.errorTxt}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </MaterialTable>
              </TableContainer>
            </div>
          </div>

          <div className={"card-footer"}>
            <button type="button" className={"btn btn-secondary"} onClick={() => this.props.handleCloseModal()}>
              Cancel
            </button>
          </div>
        </div>
      </>
    );
  }
}
